import { DateTimePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import VeiculoViagem from "model/gestao/frotas/VeiculoViagem";
import VeiculoViagemFinalizar from "model/gestao/frotas/VeiculoViagemFinalizar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import VeiculoViagemService from "service/gestao/frotas/VeiculoViagemService";
import { converterDataHora } from "utils/convert";

type Props = {
    visible: boolean;
    onHide: () => void;
    veiculoViagem: VeiculoViagem;
    onConfirm: () => void;
}

const veiculoViagemService = new VeiculoViagemService();
export default function ModalVeiculoViagemFinalizar(props: Props) {

    const { msgErro, msgSucesso, msgAlerta } = useToastContext();

    const [dataFim, setDataFim] = useState<Date | null>(new Date());

    function validar() {
        if (!dataFim) {
            msgAlerta("Atenção", "Informe uma Data/hora válida para o fim da viagem.");
            return false;
        }
        return true;
    }

    const handleConfirm = () => {
        if (!validar()) {
            return;
        }
        const dados = new VeiculoViagemFinalizar();
        dados.id = props.veiculoViagem.id!;
        dados.fimViagemMilisegundos = dataFim!.getTime();
        veiculoViagemService.finalizar(dados)
            .then(() => {
                msgSucesso("Sucesso", "Viagem finalizada com sucesso.");
                props.onConfirm();
            })
            .catch((e) => {
                msgErro("Erro", e.data?.message || "Ocorreu um erro ao finalizar a viagem.");
            });

    }

    return (
        <Dialog
            header="Finalizar viagem"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Salvar" icon="pi pi-check" onClick={() => handleConfirm()} />
            </>}
        >
            <div>
                <div style={{ display: 'flex', gap: 4 }}>
                    <Label obrigatorio >Início da viagem</Label>
                    <span>{converterDataHora(props.veiculoViagem.inicioViagem)}</span>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Label obrigatorio >Fim da viagem</Label>
                <DateTimePicker
                    slotProps={{
                        popper: {
                            disablePortal: true,
                        },
                    }}
                    sx={{ width: '300px' }}
                    value={dayjs(dataFim)}
                    ampm={false}
                    format={"DD/MM/YYYY HH:mm"}
                    onChange={value => {
                        setDataFim(value?.toDate() || null)
                    }}
                />
            </div>


        </Dialog>
    );

}